function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
export var FETCH_USERS_BEGIN = "FETCH_USERS_BEGIN";
export var FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export var FETCH_USER_BEGIN = "FETCH_USER_BEGIN";
export var FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export var FETCH_AVATARS_BEGIN = "FETCH_AVATARS_BEGIN";
export var FETCH_AVATARS_SUCCESS = "FETCH_AVATARS_SUCCESS";
export var LOG_ERROR = "LOG_ERROR";
export var LOG_DEBUG_MESSAGE = "LOG_DEBUG_MESSAGE";
export var LOAD_API_BEGIN = "LOAD_API_BEGIN";
export var LOAD_API_SUCCESS = "LOAD_API_SUCCESS";
export var LOAD_API_CANCELLED = "LOAD_API_CANCELLED";
export var BEGIN_LMS_SESSION = "BEGIN_LMS_SESSION";
export var END_LMS_SESSION = "END_LMS_SESSION";
export var GET_COMPLETED_SLIDES_BEGIN = "GET_COMPLETED_SLIDES_BEGIN";
export var GET_COMPLETED_SLIDES_SUCCESS = "GET_COMPLETED_SLIDES_SUCCESS";
export var GET_FAVORITES_BEGIN = "GET_FAVORITES_BEGIN";
export var GET_FAVORITES_SUCCESS = "GET_FAVORITES_SUCCESS";
export var TOGGLE_FAVORITE = "TOGGLE_FAVORITE";
export var GET_KEY_VALUE_STORE_BEGIN = "GET_KEY_VALUE_STORE_BEGIN";
export var GET_KEY_VALUE_STORE_SUCCESS = "GET_KEY_VALUE_STORE_SUCCESS";
export var SET_KEY_VALUE = "SET_KEY_VALUE";
export var DELETE_KEY_VALUE = "DELETE_KEY_VALUE";
export var SET_CURRENT_SLIDE = "SET_CURRENT_SLIDE";
export var COMPLETE_SLIDE = "COMPLETE_SLIDE";
export var SET_LAST_VISITED_SLIDE = "SET_LAST_VISITED_SLIDE";
export var SET_CBOOK_PROGRESS = "SET_CBOOK_PROGRESS";
export var NAV_NEXT_SLIDE = "NAV_NEXT_SLIDE";
export var NAV_PREV_SLIDE = "NAV_PREV_SLIDE";
export var NAV_GOTO_SLIDE = "NAV_GOTO_SLIDE";
export var SET_MEDIA = "SET_MEDIA";
export var FETCH_CBOOK_BEGIN = "FETCH_CBOOK_BEGIN";
export var FETCH_CBOOK_SUCCESS = "FETCH_CBOOK_SUCCESS";
export var FETCH_CONTENT_BEGIN = "FETCH_CONTENT_BEGIN";
export var FETCH_CONTENT_SUCCESS = "FETCH_CONTENT_SUCCESS";
export var FETCH_CONTENT_CANCELLED = "FETCH_CONTENT_CANCELLED";
export var FETCH_CLAIMS_BEGIN = "FETCH_CLAIMS_BEGIN";
export var FETCH_CLAIMS_SUCCESS = "FETCH_CLAIMS_SUCCESS";
export var SET_UI_VISIBLILITY_STATE = "SET_UI_VISIBLILITY_STATE";
export var SET_STORY_MODE = "SET_STORY_MODE";
export var FETCH_BONUS_MATERIAL_BEGIN = "FETCH_BONUS_MATERIAL_BEGIN";
export var FETCH_BONUS_MATERIAL_SUCCESS = "FETCH_BONUS_MATERIAL_SUCCESS";
export var FETCH_LOCALE_BEGIN = "FETCH_LOCALE_BEGIN";
export var FETCH_LOCALE_SUCCESS = "FETCH_LOCALE_SUCCESS";
export var SEARCH_BEGIN = "SEARCH_BEGIN";
export var SEARCH_SUCCESS = "SEARCH_SUCCESS";
export var SEARCH_CANCELLED = "SEARCH_CANCELLED";
export var CLEAR_SEARCH = "CLEAR_SEARCH";
export var FETCH_SEARCHABLE_BEGIN = "FETCH_SEARCHABLE_BEGIN";
export var FETCH_SEARCHABLE_SUCCESS = "FETCH_SEARCHABLE_SUCCESS";
export var FETCH_RATING_BEGIN = "FETCH_RATING_BEGIN";
export var FETCH_RATING_SUCCESS = "FETCH_RATING_SUCCESS";
export var UPDATE_RATING_BEGIN = "UPDATE_RATING_BEGIN";
export var UPDATE_RATING_SUCCESS = "UPDATE_RATING_SUCCESS";
export var SET_STUDENT = "SET_STUDENT";
export var SEND_NOTIFICATION = "SEND_NOTIFICATION";
export var DISMISS_NOTIFICATION = "DISMISS_NOTIFICATION";
export var LOGIN_BEGIN = "LOGIN_BEGIN";
export var LOGIN_SUCCESS = "LOGIN_SUCCESS";
export var FETCH_SOCIAL_CONFIG_BEGIN = "FETCH_SOCIAL_CONFIG_BEGIN";
export var FETCH_SOCIAL_CONFIG_SUCCESS = "FETCH_SOCIAL_CONFIG_SUCCESS";
export var SET_SOCIAL_API_CONFIG = "SET_SOCIAL_API_CONFIG";
export var FETCH_GROUPS_BEGIN = "FETCH_GROUPS_BEGIN";
export var FETCH_GROUPS_SUCCESS = "FETCH_GROUPS_SUCCESS";
export var CREATE_GROUP_BEGIN = "CREATE_GROUP_BEGIN";
export var CREATE_GROUP_SUCCESS = "CREATE_GROUP_SUCCESS";
export var UPDATE_GROUP_BEGIN = "UPDATE_GROUP_BEGIN";
export var UPDATE_GROUP_SUCCESS = "UPDATE_GROUP_SUCCESS";
export var TOGGLE_GROUP_VISIBILITY_BEGIN = "TOGGLE_GROUP_VISIBILITY_BEGIN";
export var TOGGLE_GROUP_VISIBILITY_SUCCESS = "TOGGLE_GROUP_VISIBILITY_SUCCESS";
export var FETCH_TOPICS_BEGIN = "FETCH_TOPICS_BEGIN";
export var FETCH_TOPICS_SUCCESS = "FETCH_TOPICS_SUCCESS";
export var FETCH_SINGLE_TOPIC_BEGIN = "FETCH_SINGLE_TOPIC_BEGIN";
export var FETCH_SINGLE_TOPIC_SUCCESS = "FETCH_SINGLE_TOPIC_SUCCESS";
export var CREATE_TOPIC_BEGIN = "CREATE_TOPIC_BEGIN";
export var CREATE_TOPIC_SUCCESS = "CREATE_TOPIC_SUCCESS";
export var SELECT_SEARCHED_TOPIC = "SELECT_SEARCHED_TOPIC";
export var SELECT_TOPIC = "SELECT_TOPIC";
export var SEARCH_TOPICS_BEGIN = "SEARCH_TOPICS_BEGIN";
export var SEARCH_TOPICS_SUCCESS = "SEARCH_TOPICS_SUCCESS";
export var CREATE_ACTIVITY_SUCCESS = "CREATE_ACTIVITY_SUCCESS";
export var GET_TWEET_VERSION = "GET_TWEET_VERSION";
export var ENDORSE_DISCLAIMER_BEGIN = "ENDORSE_DISCLAIMER_BEGIN";
export var ENDORSE_DISCLAIMER_SUCCESS = "ENDORSE_DISCLAIMER_SUCCESS";
export var INIT_EXAM = "INIT_EXAM";
export var START_EXAM = "START_EXAM";
export var EVALUATE_INTERACTION = "EVALUATE_INTERACTION";
export var FINISH_EXAM = "FINISH_EXAM";
export var RESET_EXAM = "RESET_EXAM";
export var SET_EXAM_POSITION = "SET_EXAM_POSITION";
export var FETCH_EXAM_INTERACTIONS_BEGIN = "FETCH_EXAM_INTERACTIONS_BEGIN";
export var FETCH_EXAM_INTERACTIONS_SUCCESS = "FETCH_EXAM_INTERACTIONS_SUCCESS";
export var FETCH_EXAM_INTERACTIONS_CANCELED = "FETCH_EXAM_INTERACTIONS_CANCELED";
export var GET_EXAM_DATA_BEGIN = "GET_EXAM_DATA_BEGIN";
export var GET_EXAM_DATA_SUCCESS = "GET_EXAM_DATA_SUCCESS";
export var SET_COURSE_STATUS_BEGIN = "SET_COURSE_STATUS_BEGIN";
export var SET_COURSE_STATUS_SUCCESS = "SET_COURSE_STATUS_SUCCESS";
export var FETCH_ACTIVITIES_BEGIN = "FETCH_ACTIVITIES_BEGIN";
export var FETCH_ACTIVITIES_SUCCESS = "FETCH_ACTIVITIES_SUCCESS";
export var INIT_ENGAGEMENT_SESSION = "INIT_ENGAGEMENT_SESSION";
export var FETCH_SOCIAL_CHART_DATA_BEGIN = "FETCH_SOCIAL_CHART_DATA_BEGIN";
export var FETCH_SOCIAL_CHART_DATA_SUCCESS = "FETCH_SOCIAL_CHART_DATA_SUCCESS";
export var UPDATE_SOCIAL_CHART_DATA_BEGIN = "UPDATE_SOCIAL_CHART_DATA_BEGIN";
export var UPDATE_SOCIAL_CHART_DATA_SUCCESS = "UPDATE_SOCIAL_CHART_DATA_SUCCESS";
export var FETCH_COMMUNITY_CHART_DATA_BEGIN = "FETCH_COMMUNITY_CHART_DATA_BEGIN";
export var FETCH_COMMUNITY_CHART_DATA_SUCCESS = "FETCH_COMMUNITY_CHART_DATA_SUCCESS";
export var FETCH_NOTES_BEGIN = "FETCH_NOTES_BEGIN";
export var FETCH_NOTES_SUCCESS = "FETCH_NOTES_SUCCESS";
export var FETCH_SINGLE_NOTE_BEGIN = "FETCH_SINGLE_NOTE";
export var FETCH_SINGLE_NOTE_SUCCESS = "FETCH_SINGLE_NOTE_SUCCESS";
export var FETCH_PRINT_NOTES_BEGIN = "FETCH_PRINT_NOTES_BEGIN";
export var FETCH_PRINT_NOTES_SUCCESS = "FETCH_PRINT_NOTES_SUCCESS";
export var DELETE_NOTE_BEGIN = "DELETE_NOTE_BEGIN";
export var DELETE_NOTE_SUCCESS = "DELETE_NOTE_SUCCESS";
export var SELECT_NOTE = "SELECT_NOTE";
export var REGISTER_ENDPOINT = "REGISTER_ENDPOINT";
export var UPDATE_CONNECTION = "UPDATE_CONNECTION";
export var SEND_ALERT = "SEND_ALERT";
export var DISMISS_ALERT = "DISMISS_ALERT";
export var FETCH_ACTIVITY_BEGIN = "FETCH_ACTIVITY_BEGIN";
export var FETCH_ACTIVITY_SUCCESS = "FETCH_ACTIVITY_SUCCESS";
export var UPLOAD_ACTIVITY_FILE_BEGIN = "UPLOAD_ACTIVITY_FILE_BEGIN";
export var UPLOAD_ACTIVITY_FILE_SUCCESS = "UPLOAD_ACTIVITY_FILE_SUCCESS";
export var UPDATE_TOPIC_SUCCESS = "UPDATE_TOPIC_SUCCESS";
export var UPDATE_INTL = "UPDATE_INTL";
var createAction = function(type) {
    return function(payload) {
        return _objectSpread({
            type: type
        }, payload);
    };
};
export var fetchUsers = createAction(FETCH_USERS_BEGIN);
export var fetchUsersSuccess = createAction(FETCH_USERS_SUCCESS);
export var fetchAvatars = createAction(FETCH_AVATARS_BEGIN);
export var fetchAvatarsSuccess = createAction(FETCH_AVATARS_SUCCESS);
export var logError = createAction(LOG_ERROR);
export var logDebugMessage = createAction(LOG_DEBUG_MESSAGE);
export var loadAPI = createAction(LOAD_API_BEGIN);
export var loadAPISuccess = createAction(LOAD_API_SUCCESS);
export var loadAPICanceled = createAction(LOAD_API_CANCELLED);
export var beginLMSSession = createAction(BEGIN_LMS_SESSION);
export var endLMSSession = createAction(END_LMS_SESSION);
export var getCompletedSlides = createAction(GET_COMPLETED_SLIDES_BEGIN);
export var getCompletedSlidesSuccess = createAction(GET_COMPLETED_SLIDES_SUCCESS);
export var getFavorites = createAction(GET_FAVORITES_BEGIN);
export var getFavoritesSuccess = createAction(GET_FAVORITES_SUCCESS);
export var toggleFavorite = createAction(TOGGLE_FAVORITE);
export var getKeyValueStore = createAction(GET_KEY_VALUE_STORE_BEGIN);
export var getKeyValueStoreSuccess = createAction(GET_KEY_VALUE_STORE_SUCCESS);
export var setKeyValue = createAction(SET_KEY_VALUE);
export var deleteKeyValue = createAction(DELETE_KEY_VALUE);
export var setLastVisitedSlide = createAction(SET_LAST_VISITED_SLIDE);
export var setCurrentSlide = createAction(SET_CURRENT_SLIDE);
export var completeSlide = createAction(COMPLETE_SLIDE);
export var setCbookProgress = createAction(SET_CBOOK_PROGRESS);
export var nextSlide = createAction(NAV_NEXT_SLIDE);
export var prevSlide = createAction(NAV_PREV_SLIDE);
export var setMedia = createAction(SET_MEDIA);
export var goToSlide = createAction(NAV_GOTO_SLIDE);
export var fetchCBook = createAction(FETCH_CBOOK_BEGIN);
export var fetchCBookSuccess = createAction(FETCH_CBOOK_SUCCESS);
export var fetchContent = createAction(FETCH_CONTENT_BEGIN);
export var fetchContentSuccess = createAction(FETCH_CONTENT_SUCCESS);
export var fetchContentCanceled = createAction(FETCH_CONTENT_CANCELLED);
export var fetchClaims = createAction(FETCH_CLAIMS_BEGIN);
export var fetchClaimsSuccess = createAction(FETCH_CLAIMS_SUCCESS);
export var setUIVisibilityState = createAction(SET_UI_VISIBLILITY_STATE);
export var setStoryMode = createAction(SET_STORY_MODE);
export var fetchBonusMaterial = createAction(FETCH_BONUS_MATERIAL_BEGIN);
export var fetchBonusMaterialSuccess = createAction(FETCH_BONUS_MATERIAL_SUCCESS);
export var fetchLocale = createAction(FETCH_LOCALE_BEGIN);
export var fetchLocaleSuccess = createAction(FETCH_LOCALE_SUCCESS);
export var search = createAction(SEARCH_BEGIN);
export var searchSuccess = createAction(SEARCH_SUCCESS);
export var searchCanceled = createAction(SEARCH_CANCELLED);
export var clearSearch = createAction(CLEAR_SEARCH);
export var fetchSearchable = createAction(FETCH_SEARCHABLE_BEGIN);
export var fetchSearchableSuccess = createAction(FETCH_SEARCHABLE_SUCCESS);
export var setStudent = createAction(SET_STUDENT);
export var sendNotification = createAction(SEND_NOTIFICATION);
export var dismissNotification = createAction(DISMISS_NOTIFICATION);
export var startExam = createAction(START_EXAM);
export var finishExam = createAction(FINISH_EXAM);
export var initExam = createAction(INIT_EXAM);
export var resetExam = createAction(RESET_EXAM);
export var setExamPosition = createAction(SET_EXAM_POSITION);
export var evaluateInteraction = createAction(EVALUATE_INTERACTION);
export var fetchExamInteractions = createAction(FETCH_EXAM_INTERACTIONS_BEGIN);
export var fetchExamInteractionsSuccess = createAction(FETCH_EXAM_INTERACTIONS_SUCCESS);
export var fetchExamInteractionsCanceled = createAction(FETCH_EXAM_INTERACTIONS_CANCELED);
export var getExamData = createAction(GET_EXAM_DATA_BEGIN);
export var getExamDataSuccess = createAction(GET_EXAM_DATA_SUCCESS);
export var setCourseStatus = createAction(SET_COURSE_STATUS_BEGIN);
export var setCourseStatusSuccess = createAction(SET_COURSE_STATUS_SUCCESS);
export var sendAlert = createAction(SEND_ALERT);
export var dismissAlert = createAction(DISMISS_ALERT);
/**
 *  ENGAGEMENT SERVER A.K.A. TWEET A.K.A. SOCIAL / COMMUNITY FEATURES
 */ export var login = createAction(LOGIN_BEGIN);
export var loginSuccess = createAction(LOGIN_SUCCESS);
export var getTweetVersion = createAction(GET_TWEET_VERSION);
export var endorseDisclaimer = createAction(ENDORSE_DISCLAIMER_BEGIN);
export var endorseDisclaimerSuccess = createAction(ENDORSE_DISCLAIMER_SUCCESS);
export var fetchRating = createAction(FETCH_RATING_BEGIN);
export var fetchRatingSuccess = createAction(FETCH_RATING_SUCCESS);
export var updateRating = createAction(UPDATE_RATING_BEGIN);
export var updateRatingSuccess = createAction(UPDATE_RATING_SUCCESS);
export var fetchSocialConfig = createAction(FETCH_SOCIAL_CONFIG_BEGIN);
export var fetchSocialConfigSuccess = createAction(FETCH_SOCIAL_CONFIG_SUCCESS);
export var initEngagementSession = createAction(INIT_ENGAGEMENT_SESSION);
export var registerEndpoint = createAction(REGISTER_ENDPOINT);
export var updateConnection = createAction(UPDATE_CONNECTION);
export var updateTopicSuccess = createAction(UPDATE_TOPIC_SUCCESS);
export var fetchGroupsSuccess = createAction(FETCH_GROUPS_SUCCESS);
export var fetchGroups = createAction(FETCH_GROUPS_BEGIN);
export var createGroup = createAction(CREATE_GROUP_BEGIN);
export var createGroupSuccess = createAction(CREATE_GROUP_SUCCESS);
export var updateGroup = createAction(UPDATE_GROUP_BEGIN);
export var updateGroupSuccess = createAction(UPDATE_GROUP_SUCCESS);
export var toggleGroupVisibility = createAction(TOGGLE_GROUP_VISIBILITY_BEGIN);
export var toggleGroupVisibilitySuccess = createAction(TOGGLE_GROUP_VISIBILITY_SUCCESS);
export var fetchSocialChartData = createAction(FETCH_SOCIAL_CHART_DATA_BEGIN);
export var fetchSocialChartDataSuccess = createAction(FETCH_SOCIAL_CHART_DATA_SUCCESS);
export var updateSocialChartData = createAction(UPDATE_SOCIAL_CHART_DATA_BEGIN);
export var updateSocialChartDataSuccess = createAction(UPDATE_SOCIAL_CHART_DATA_SUCCESS);
export var fetchCommunityChartData = createAction(FETCH_COMMUNITY_CHART_DATA_BEGIN);
export var fetchCommunityChartDataSuccess = createAction(FETCH_COMMUNITY_CHART_DATA_SUCCESS);
export var fetchAllTopics = createAction(FETCH_TOPICS_BEGIN);
export var fetchAllTopicsSuccess = createAction(FETCH_TOPICS_SUCCESS);
export var fetchSingleTopic = createAction(FETCH_SINGLE_TOPIC_BEGIN);
export var fetchSingleTopicSuccess = createAction(FETCH_SINGLE_TOPIC_SUCCESS);
export var selectSearchedTopic = createAction(SELECT_SEARCHED_TOPIC);
export var selectTopic = createAction(SELECT_TOPIC);
export var searchTopics = createAction(SEARCH_TOPICS_BEGIN);
export var searchTopicsSuccess = createAction(SEARCH_TOPICS_SUCCESS);
export var fetchNotes = createAction(FETCH_NOTES_BEGIN);
export var fetchNotesSuccess = createAction(FETCH_NOTES_SUCCESS);
export var fetchSingleNote = createAction(FETCH_SINGLE_NOTE_BEGIN);
export var fetchSingleNoteSuccess = createAction(FETCH_SINGLE_NOTE_SUCCESS);
export var fetchPrintNotes = createAction(FETCH_PRINT_NOTES_BEGIN);
export var fetchPrintNotesSuccess = createAction(FETCH_PRINT_NOTES_SUCCESS);
export var deleteNote = createAction(DELETE_NOTE_BEGIN);
export var deleteNoteSuccess = createAction(DELETE_NOTE_SUCCESS);
export var selectNote = createAction(SELECT_NOTE);
export var fetchActivity = createAction(FETCH_ACTIVITY_BEGIN);
export var fetchActivitySuccess = createAction(FETCH_ACTIVITY_SUCCESS);
export var fetchActivitiesSuccess = createAction(FETCH_ACTIVITIES_SUCCESS);
export var uploadActivityFile = createAction(UPLOAD_ACTIVITY_FILE_BEGIN);
export var uploadActivityFileSuccess = createAction(UPLOAD_ACTIVITY_FILE_SUCCESS);
export var createActivitySuccess = createAction(CREATE_ACTIVITY_SUCCESS);
